module.exports = __webpack_public_path__ + "img/yuan.02633202.png";